export enum ROW_TYPES {
  GENERAL = 'GENERAL',
  TEXT = 'TEXT',
  SUBTOTAL = 'SUBTOTAL',
  SUBROW = 'SUB_ROW',
  TOTAL = 'TOTAL'
}
